export default function () {
  const PERMISSIONS = {
    ADMIN: {
      id: 1,
      code: "ADMIN",
    },
    ARTICLE_REGIST: {
      id: 2,
      code: "ARTICLE_REGIST",
    },
    ARTICLE_DELETE: {
      id: 3,
      code: "ARTICLE_DELETE",
    },
    PUBLISH_INSTANTLY: {
      id: 4,
      code: "PUBLISH_INSTANTLY",
    },
    PREDICTION: {
      id: 5,
      code: "PREDICTION",
    },
    SPECIAL_SITE: {
      id: 6,
      code: "SPECIAL_SITE",
    },
    ARTICLE_RANKING: {
      id: 7,
      code: "ARTICLE_RANKING",
    },
    RANKING: {
      id: 8,
      code: "RANKING",
    },
    XML_DOWNLOAD: {
      id: 9,
      code: "XML_DOWNLOAD",
    },
    MAINTENANCE: {
      id: 10,
      code: "MAINTENANCE",
    },
  };

  // 特定の権限がリストに含まれているかどうかを確認するヘルパー関数
  const hasPermission = (permissionList, permissionCode) => {
    const permission = PERMISSIONS[permissionCode];
    if (!permission) {
      console.warn(`Invalid permission code: ${permissionCode}`);
      return false;
    }
    return permissionList.includes(PERMISSIONS[permissionCode].code);
  };

  // 特定のIDを持つ権限がリストに含まれているかどうかを確認するヘルパー関数
  const hasPermissionById = (permissionList, permissionId) => {
    return Object.values(PERMISSIONS).some(
      (permission) =>
        permission.id === permissionId &&
        permissionList.includes(permission.code)
    );
  };
  return {
    PERMISSIONS,
    hasPermission,
    hasPermissionById,
  };
}
